import React, { useEffect, useState, createElement } from 'react';
import { CheckCircleIcon, XCircleIcon, RefreshCwIcon, InfoIcon, MailIcon, CopyIcon, CheckIcon, ImageIcon } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { emailNotificationService, EmailConfig } from '../../utils/emailNotifications';
const createScriptCode = () => {
  const cssStyles = 'body{margin:0;padding:0;font-family:Arial,sans-serif}.container{max-width:600px;margin:0 auto;background:#fff}.header{background:linear-gradient(135deg,#667eea 0%,#764ba2 100%);padding:40px 30px;text-align:center}.logo{max-width:180px;height:auto;margin-bottom:20px}.header-title{color:#fff;font-size:24px;font-weight:700;margin:0}.content{padding:40px 30px}.greeting{font-size:18px;color:#1f2937;margin-bottom:20px;font-weight:600}.message{font-size:16px;color:#4b5563;line-height:1.6;margin-bottom:30px}.details-card{background:#f9fafb;border:2px solid #e5e7eb;border-radius:12px;padding:24px;margin:30px 0}.detail-row{padding:12px 0;border-bottom:1px solid #e5e7eb}.detail-row:last-child{border-bottom:none}.detail-label{font-weight:600;color:#374151}.detail-value{color:#1f2937}.alert-card{background:#fef2f2;border-left:4px solid #ef4444;padding:20px;margin:20px 0;border-radius:8px}.success-card{background:#f0fdf4;border-left:4px solid #10b981;padding:20px;margin:20px 0;border-radius:8px}.warning-card{background:#fffbeb;border-left:4px solid #f59e0b;padding:20px;margin:20px 0;border-radius:8px}.footer{background:#f9fafb;padding:30px;text-align:center;border-top:1px solid #e5e7eb}.footer-text{color:#6b7280;font-size:14px;margin:5px 0}';
  return `function doPost(e) {
  try {
    var data = JSON.parse(e.postData.contents);
    if (data.action === 'appointment_created' || data.action === 'appointment_updated' || data.action === 'appointment_cancelled' || data.action === 'appointment_rescheduled') {
      return ContentService.createTextOutput(JSON.stringify(handleEmailNotification(data))).setMimeType(ContentService.MimeType.JSON);
    }
    var sheetName = data.sheetName || 'Citas';
    var ss = SpreadsheetApp.getActiveSpreadsheet();
    var sheet = ss.getSheetByName(sheetName);
    if (!sheet) {
      sheet = ss.insertSheet(sheetName);
      sheet.appendRow(['ID', 'Paciente', 'Doctor', 'Servicio', 'Fecha', 'Hora', 'Duración (min)', 'Estado', 'Notas', 'Creado', 'Actualizado']);
      var headerRange = sheet.getRange(1, 1, 1, 11);
      headerRange.setBackground('#4285f4');
      headerRange.setFontColor('#ffffff');
      headerRange.setFontWeight('bold');
      sheet.setFrozenRows(1);
    }
    if (data.action === 'test') return ContentService.createTextOutput(JSON.stringify({success: true})).setMimeType(ContentService.MimeType.JSON);
    if (data.action === 'sync_all') {
      if (sheet.getLastRow() > 1) sheet.deleteRows(2, sheet.getLastRow() - 1);
      if (data.data && data.data.length > 0) {
        var rows = data.data.map(function(apt) {
          return [apt.id, apt.patientName, apt.doctorName, apt.serviceName, apt.date, apt.time, apt.duration, apt.status, apt.notes, apt.createdAt, apt.updatedAt];
        });
        sheet.getRange(2, 1, rows.length, 11).setValues(rows);
      }
      return ContentService.createTextOutput(JSON.stringify({success: true})).setMimeType(ContentService.MimeType.JSON);
    }
    if (data.action === 'create') {
      var apt = data.data;
      sheet.appendRow([apt.id, apt.patientName, apt.doctorName, apt.serviceName, apt.date, apt.time, apt.duration, apt.status, apt.notes, apt.createdAt, apt.updatedAt]);
    }
    if (data.action === 'update') {
      var apt = data.data;
      var values = sheet.getDataRange().getValues();
      for (var i = 1; i < values.length; i++) {
        if (values[i][0] === apt.id) {
          sheet.getRange(i + 1, 1, 1, 11).setValues([[apt.id, apt.patientName, apt.doctorName, apt.serviceName, apt.date, apt.time, apt.duration, apt.status, apt.notes, apt.createdAt, apt.updatedAt]]);
          break;
        }
      }
    }
    if (data.action === 'delete') {
      var apt = data.data;
      var values = sheet.getDataRange().getValues();
      for (var i = 1; i < values.length; i++) {
        if (values[i][0] === apt.id) {
          sheet.deleteRow(i + 1);
          break;
        }
      }
    }
    return ContentService.createTextOutput(JSON.stringify({success: true})).setMimeType(ContentService.MimeType.JSON);
  } catch (error) {
    return ContentService.createTextOutput(JSON.stringify({success: false, error: error.toString()})).setMimeType(ContentService.MimeType.JSON);
  }
}

function handleEmailNotification(requestData) {
  var senderName = requestData.senderName || 'Savidna CRM';
  var logoUrl = requestData.logoUrl || '';
  var emailData = requestData.data;
  var subject = '';
  var body = '';
  var css = '${cssStyles}';
  var styles = '<style>{`;
  ' + css + '`}</style>';
  
  if (requestData.action === 'appointment_created') {
    subject = '✅ Cita Confirmada - ' + senderName;
    body = '<!DOCTYPE html><html><head><meta charset="UTF-8">' + styles + '</head><body><div class="container"><div class="header">';
    if (logoUrl && logoUrl.length > 0) {
      body += '<img src="' + logoUrl + '" alt="Logo" class="logo">';
    }
    body += '<h1 class="header-title">¡Cita Confirmada!</h1></div><div class="content"><p class="greeting">Hola ' + emailData.patientName + ',</p><p class="message">Tu cita ha sido agendada exitosamente.</p><div class="success-card"><div class="detail-row"><span class="detail-label">📅 Fecha:</span> <span class="detail-value"><strong>' + emailData.date + '</strong></span></div><div class="detail-row"><span class="detail-label">🕐 Hora:</span> <span class="detail-value"><strong>' + emailData.time + '</strong></span></div><div class="detail-row"><span class="detail-label">👨‍⚕️ Doctor:</span> <span class="detail-value">Dr. ' + emailData.doctorName + '</span></div><div class="detail-row"><span class="detail-label">🏥 Servicio:</span> <span class="detail-value">' + emailData.serviceName + '</span></div><div class="detail-row"><span class="detail-label">⏱️ Duración:</span> <span class="detail-value">' + emailData.duration + ' minutos</span></div>';
    if (emailData.notes) body += '<div class="detail-row"><span class="detail-label">📝 Notas:</span> <span class="detail-value">' + emailData.notes + '</span></div>';
    body += '</div><p class="message" style="background:#eff6ff;padding:16px;border-radius:8px"><strong>💡 Recordatorio:</strong> Por favor llega 10 minutos antes.</p></div><div class="footer"><p class="footer-text">Correo automático de <strong>' + senderName + '</strong></p></div></div></body></html>';
  }
  
  if (requestData.action === 'appointment_cancelled') {
    subject = '❌ Cita Cancelada - ' + senderName;
    body = '<!DOCTYPE html><html><head><meta charset="UTF-8">' + styles + '</head><body><div class="container"><div class="header" style="background:linear-gradient(135deg,#ef4444 0%,#dc2626 100%)">';
    if (logoUrl && logoUrl.length > 0) {
      body += '<img src="' + logoUrl + '" alt="Logo" class="logo">';
    }
    body += '<h1 class="header-title">Cita Cancelada</h1></div><div class="content"><p class="greeting">Hola ' + emailData.patientName + ',</p><p class="message">Tu cita ha sido cancelada.</p><div class="alert-card"><div class="detail-row"><span class="detail-label">📅 Fecha:</span> <span class="detail-value">' + emailData.date + '</span></div><div class="detail-row"><span class="detail-label">🕐 Hora:</span> <span class="detail-value">' + emailData.time + '</span></div><div class="detail-row"><span class="detail-label">👨‍⚕️ Doctor:</span> <span class="detail-value">Dr. ' + emailData.doctorName + '</span></div>';
    if (emailData.cancelReason) body += '<div class="detail-row"><span class="detail-label">📋 Motivo:</span> <span class="detail-value">' + emailData.cancelReason + '</span></div>';
    body += '</div><p class="message">Si deseas reagendar, contáctanos.</p></div><div class="footer"><p class="footer-text">Correo automático de <strong>' + senderName + '</strong></p></div></div></body></html>';
  }
  
  if (requestData.action === 'appointment_rescheduled') {
    subject = '🔄 Cita Reprogramada - ' + senderName;
    body = '<!DOCTYPE html><html><head><meta charset="UTF-8">' + styles + '</head><body><div class="container"><div class="header" style="background:linear-gradient(135deg,#f59e0b 0%,#d97706 100%)">';
    if (logoUrl && logoUrl.length > 0) {
      body += '<img src="' + logoUrl + '" alt="Logo" class="logo">';
    }
    body += '<h1 class="header-title">Cita Reprogramada</h1></div><div class="content"><p class="greeting">Hola ' + emailData.patientName + ',</p><p class="message">Tu cita ha sido reprogramada.</p>';
    if (emailData.oldDate && emailData.oldTime) body += '<div class="warning-card"><p style="margin:0"><strong>Fecha anterior:</strong> ' + emailData.oldDate + ' a las ' + emailData.oldTime + '</p></div>';
    body += '<div class="success-card"><div class="detail-row"><span class="detail-label">📅 Nueva Fecha:</span> <span class="detail-value"><strong>' + emailData.date + '</strong></span></div><div class="detail-row"><span class="detail-label">🕐 Nueva Hora:</span> <span class="detail-value"><strong>' + emailData.time + '</strong></span></div><div class="detail-row"><span class="detail-label">👨‍⚕️ Doctor:</span> <span class="detail-value">Dr. ' + emailData.doctorName + '</span></div><div class="detail-row"><span class="detail-label">🏥 Servicio:</span> <span class="detail-value">' + emailData.serviceName + '</span></div></div><p class="message" style="background:#eff6ff;padding:16px;border-radius:8px"><strong>💡 Recordatorio:</strong> Por favor llega 10 minutos antes.</p></div><div class="footer"><p class="footer-text">Correo automático de <strong>' + senderName + '</strong></p></div></div></body></html>';
  }
  
  if (requestData.action === 'appointment_updated') {
    subject = '📝 Cita Actualizada - ' + senderName;
    body = '<!DOCTYPE html><html><head><meta charset="UTF-8">' + styles + '</head><body><div class="container"><div class="header" style="background:linear-gradient(135deg,#3b82f6 0%,#2563eb 100%)">';
    if (logoUrl && logoUrl.length > 0) {
      body += '<img src="' + logoUrl + '" alt="Logo" class="logo">';
    }
    body += '<h1 class="header-title">Cita Actualizada</h1></div><div class="content"><p class="greeting">Hola ' + emailData.patientName + ',</p><p class="message">Los detalles de tu cita han sido actualizados:</p><div class="details-card"><div class="detail-row"><span class="detail-label">📅 Fecha:</span> <span class="detail-value">' + emailData.date + '</span></div><div class="detail-row"><span class="detail-label">🕐 Hora:</span> <span class="detail-value">' + emailData.time + '</span></div><div class="detail-row"><span class="detail-label">👨‍⚕️ Doctor:</span> <span class="detail-value">Dr. ' + emailData.doctorName + '</span></div><div class="detail-row"><span class="detail-label">🏥 Servicio:</span> <span class="detail-value">' + emailData.serviceName + '</span></div></div></div><div class="footer"><p class="footer-text">Correo automático de <strong>' + senderName + '</strong></p></div></div></body></html>';
  }
  
  return sendEmail(emailData.patientEmail, subject, body);
}

function sendEmail(recipient, subject, body) {
  try {
    MailApp.sendEmail({to: recipient, subject: subject, htmlBody: body});
    return {success: true};
  } catch (error) {
    return {success: false, error: error.toString()};
  }
}`;
};
const SCRIPT_CODE = createScriptCode();
export function EmailNotificationsConfig() {
  const [config, setConfig] = useState<EmailConfig>({
    webAppUrl: '',
    enabled: false,
    senderName: 'Savidna CRM',
    senderEmail: '',
    logoUrl: ''
  });
  const [isTesting, setIsTesting] = useState(false);
  const [testResult, setTestResult] = useState<{
    success: boolean;
    message: string;
  } | null>(null);
  const [saveMessage, setSaveMessage] = useState('');
  const [showInstructions, setShowInstructions] = useState(false);
  const [codeCopied, setCodeCopied] = useState(false);
  useEffect(() => {
    const savedConfig = emailNotificationService.getConfig();
    if (savedConfig) {
      setConfig(savedConfig);
    }
  }, []);
  const handleSave = () => {
    emailNotificationService.saveConfig(config);
    setSaveMessage('Configuración guardada correctamente');
    setTimeout(() => setSaveMessage(''), 3000);
  };
  const handleTestConnection = async () => {
    setIsTesting(true);
    setTestResult(null);
    const result = await emailNotificationService.testConnection();
    setTestResult({
      success: result.success,
      message: result.success ? 'Conexión exitosa. Los correos se enviarán automáticamente.' : result.error || 'Error al conectar'
    });
    setIsTesting(false);
  };
  const handleCopyCode = () => {
    navigator.clipboard.writeText(SCRIPT_CODE);
    setCodeCopied(true);
    setTimeout(() => setCodeCopied(false), 2000);
  };
  return <div className="space-y-6" data-id="element-878">
      <div data-id="element-879">
        <h2 className="text-xl font-bold text-gray-900 dark:text-white flex items-center gap-2" data-id="element-880">
          <MailIcon className="w-6 h-6 text-blue-600 dark:text-blue-400" data-id="element-881" />
          Notificaciones por Correo
        </h2>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1" data-id="element-882">
          Correos profesionales y personalizados para tus pacientes
        </p>
      </div>

      <Card className={`${config.enabled ? 'bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-950/30 dark:to-indigo-950/30 border-blue-200 dark:border-blue-800' : 'bg-gradient-to-br from-gray-50 to-slate-50 dark:from-gray-800/30 dark:to-slate-800/30 border-gray-200 dark:border-gray-700'}`} data-id="element-883">
        <div className="flex items-center justify-between" data-id="element-884">
          <div className="flex items-center gap-4" data-id="element-885">
            <div className={`w-14 h-14 rounded-xl flex items-center justify-center shadow-lg ${config.enabled ? 'bg-blue-500 dark:bg-blue-600 shadow-blue-500/20' : 'bg-gray-400 dark:bg-gray-600 shadow-gray-500/20'}`} data-id="element-886">
              <MailIcon className="w-7 h-7 text-white" data-id="element-887" />
            </div>
            <div data-id="element-888">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-1" data-id="element-889">
                {config.enabled ? 'Notificaciones Activas' : 'Notificaciones Inactivas'}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-890">
                {config.enabled ? 'Correos profesionales con tu logo' : 'Configura correos personalizados'}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2" data-id="element-891">
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-892">
              <input type="checkbox" checked={config.enabled} onChange={e => setConfig({
              ...config,
              enabled: e.target.checked
            })} className="sr-only peer" data-id="element-893" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600" data-id="element-894"></div>
            </label>
          </div>
        </div>
      </Card>

      {saveMessage && <div className="p-3 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg text-green-600 dark:text-green-400 text-sm" data-id="element-895">
          {saveMessage}
        </div>}

      <Card data-id="element-896">
        <div className="space-y-4" data-id="element-897">
          <Input label="URL de Google Apps Script" value={config.webAppUrl} onChange={e => setConfig({
          ...config,
          webAppUrl: e.target.value
        })} placeholder="https://script.google.com/macros/s/..." helperText="La misma URL que usas para Google Sheets" data-id="element-898" />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-899">
            <Input label="Nombre del Remitente" value={config.senderName} onChange={e => setConfig({
            ...config,
            senderName: e.target.value
          })} placeholder="Clínica Savidna" data-id="element-900" />
            <Input label="Correo (Opcional)" type="email" value={config.senderEmail} onChange={e => setConfig({
            ...config,
            senderEmail: e.target.value
          })} placeholder="contacto@clinica.com" data-id="element-901" />
          </div>

          <div data-id="element-902">
            <Input label={<span className="flex items-center gap-2" data-id="element-904">
                  <ImageIcon className="w-4 h-4" data-id="element-905" />
                  URL del Logo (Opcional)
                </span>} value={config.logoUrl || ''} onChange={e => setConfig({
            ...config,
            logoUrl: e.target.value
          })} placeholder="https://tu-sitio.com/logo.png" helperText="Sube tu logo a Imgur o tu sitio web. Recomendado: 180px de ancho" data-id="element-903" />
            {config.logoUrl && <div className="mt-3 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700" data-id="element-906">
                <p className="text-xs text-gray-500 dark:text-gray-400 mb-2" data-id="element-907">
                  Vista previa:
                </p>
                <img src={config.logoUrl} alt="Logo" className="max-w-[180px] h-auto" onError={e => {
              const target = e.currentTarget;
              target.style.display = 'none';
              const parent = target.parentElement;
              if (parent && !parent.querySelector('.error-message')) {
                const errorMsg = document.createElement('p');
                errorMsg.className = 'text-red-500 text-sm error-message';
                errorMsg.textContent = '❌ No se pudo cargar el logo. Verifica la URL.';
                parent.appendChild(errorMsg);
              }
            }} data-id="element-908" />
              </div>}
          </div>

          <div className="flex items-center gap-3 pt-4 flex-wrap" data-id="element-909">
            <Button onClick={handleSave} data-id="element-910">Guardar</Button>
            <Button variant="secondary" onClick={handleTestConnection} isLoading={isTesting} disabled={!config.webAppUrl} data-id="element-911">
              <RefreshCwIcon className="w-4 h-4" data-id="element-912" />
              Probar
            </Button>
            <Button variant="secondary" onClick={() => setShowInstructions(!showInstructions)} data-id="element-913">
              <InfoIcon className="w-4 h-4" data-id="element-914" />
              {showInstructions ? 'Ocultar' : 'Ver'} Instrucciones
            </Button>
          </div>

          {testResult && <div className={`p-3 rounded-lg border flex items-start gap-2 ${testResult.success ? 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800 text-green-700 dark:text-green-300' : 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800 text-red-700 dark:text-red-300'}`} data-id="element-915">
              {testResult.success ? <CheckCircleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-916" /> : <XCircleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-917" />}
              <div data-id="element-918">
                <p className="font-medium" data-id="element-919">{testResult.message}</p>
              </div>
            </div>}
        </div>
      </Card>

      {showInstructions && <Card data-id="element-920">
          <div className="space-y-6" data-id="element-921">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-922">
              Configuración en 3 Pasos
            </h3>

            <div className="space-y-6" data-id="element-923">
              <div className="flex gap-4" data-id="element-924">
                <div className="flex-shrink-0" data-id="element-925">
                  <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center" data-id="element-926">
                    <span className="text-blue-600 dark:text-blue-400 font-bold text-lg" data-id="element-927">
                      1
                    </span>
                  </div>
                </div>
                <div className="flex-1" data-id="element-928">
                  <h4 className="font-semibold text-gray-900 dark:text-white mb-2" data-id="element-929">
                    Abre Google Apps Script
                  </h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-930">
                    Google Sheets → Extensiones → Apps Script
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-931">
                <div className="flex-shrink-0" data-id="element-932">
                  <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center" data-id="element-933">
                    <span className="text-blue-600 dark:text-blue-400 font-bold text-lg" data-id="element-934">
                      2
                    </span>
                  </div>
                </div>
                <div className="flex-1" data-id="element-935">
                  <h4 className="font-semibold text-gray-900 dark:text-white mb-2" data-id="element-936">
                    Reemplaza TODO el código
                  </h4>

                  <div className="relative mt-3" data-id="element-937">
                    <pre className="bg-gray-900 dark:bg-gray-950 text-gray-100 p-4 rounded-lg overflow-x-auto text-xs leading-relaxed max-h-96 border border-gray-700" data-id="element-938">
                      <code data-id="element-939">{SCRIPT_CODE}</code>
                    </pre>
                    <button onClick={handleCopyCode} className="absolute top-2 right-2 p-2 bg-gray-800 hover:bg-gray-700 rounded-lg transition-colors flex items-center gap-2 text-xs text-gray-300 shadow-lg" data-id="element-940">
                      {codeCopied ? <>
                          <CheckIcon className="w-4 h-4 text-green-400" data-id="element-941" />
                          <span data-id="element-942">¡Copiado!</span>
                        </> : <>
                          <CopyIcon className="w-4 h-4" data-id="element-943" />
                          <span data-id="element-944">Copiar código</span>
                        </>}
                    </button>
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-945">
                <div className="flex-shrink-0" data-id="element-946">
                  <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center" data-id="element-947">
                    <span className="text-blue-600 dark:text-blue-400 font-bold text-lg" data-id="element-948">
                      3
                    </span>
                  </div>
                </div>
                <div className="flex-1" data-id="element-949">
                  <h4 className="font-semibold text-gray-900 dark:text-white mb-2" data-id="element-950">
                    Guarda y despliega
                  </h4>
                  <ol className="text-sm text-gray-600 dark:text-gray-400 space-y-1 list-decimal list-inside" data-id="element-951">
                    <li data-id="element-952">Guarda (Ctrl+S)</li>
                    <li data-id="element-953">Desplegar → Administrar implementaciones</li>
                    <li data-id="element-954">Editar → Nueva versión → Desplegar</li>
                  </ol>
                </div>
              </div>
            </div>

            <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4" data-id="element-955">
              <p className="text-sm text-green-700 dark:text-green-300" data-id="element-956">
                <strong data-id="element-957">✅ ¡Listo!</strong> Correos profesionales con tu logo.
              </p>
            </div>
          </div>
        </Card>}
    </div>;
}